export default {
    LOAD_STORE_GIFT_LIST_CATEGORIES (state, storegiftlistcategory) {
        state.items = storegiftlistcategory
    },
    LOAD_STORE_GIFT_LIST_CATEGORIES_ALL (state, storegiftlistcategory) {
        state.all = storegiftlistcategory
    }
}